/**
 * Utility functions for authentication
 */
import { getAuth } from 'firebase/auth';

/**
 * Validates the current Firebase token and returns whether it's valid
 * @returns {Promise<boolean>} True if token is valid, false otherwise
 */
export const validateAuthToken = async () => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    
    if (!currentUser) {
      console.log('No current user found, token invalid');
      return false;
    }
    
    // Force token refresh if it's expired
    // This will throw an error if the token is invalid/expired
    const token = await currentUser.getIdToken(true);
    
    // Check if the token exists and is not empty
    if (!token) {
      console.log('Empty token returned, considering invalid');
      return false;
    }
    
    console.log('Token validated successfully');
    return true;
  } catch (error) {
    console.error('Token validation failed:', error);
    return false;
  }
};

/**
 * Checks if the current session should be maintained or if user should be logged out
 * @returns {Promise<boolean>} True if session should be maintained, false if user should be logged out
 */
export const validateSession = async () => {
  // Skip validation for public routes
  const publicRoutes = ['/auth', '/sign-in', '/create-account', '/external-link', '/share-design', '/return-to-app'];
  const currentPath = window.location.pathname;
  
  if (publicRoutes.some(route => currentPath === route || currentPath.startsWith(route))) {
    return true;
  }
  
  const isTokenValid = await validateAuthToken();
  
  if (!isTokenValid) {
    // Clear any cached auth data
    localStorage.removeItem('authToken');
    sessionStorage.removeItem('hasRedirected');
    
    // Prevent browser back navigation from showing authenticated content
    if (!publicRoutes.includes(currentPath)) {
      window.location.replace('/auth');
    }
    return false;
  }
  
  return true;
};
